export default __webpack_public_path__ + "src/assets/backgrounds/midnight-forest4.jpg";